import { getColor } from "./getColor";
import { InvoiceIconType } from "./invoice.icon";

const TableStyleIcon = ({ active }: InvoiceIconType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.8892 24C8.7582 24 8.6302 23.948 8.5352 23.854C8.4122 23.731 8.3622 23.554 8.4022 23.386L9.4922 18.761C9.5132 18.671 9.5592 18.588 9.6252 18.522L19.1712 8.976C19.9522 8.195 21.2202 8.196 22.0002 8.976L23.4142 10.39C23.7922 10.767 24.0002 11.269 24.0002 11.803C24.0002 12.338 23.7922 12.84 23.4142 13.217L13.8682 22.763C13.8032 22.829 13.7202 22.875 13.6292 22.896L9.0042 23.986C8.9662 23.996 8.9272 24 8.8892 24ZM10.4332 19.127L9.5612 22.827L13.2622 21.955L22.7072 12.51C22.8962 12.321 23.0002 12.07 23.0002 11.803C23.0002 11.536 22.8962 11.285 22.7072 11.096L21.2932 9.682C20.9032 9.292 20.2682 9.291 19.8782 9.682L10.4332 19.127ZM13.5152 22.41H13.5252H13.5152Z"
        fill={getColor(active)}
      />
      <path
        d="M20.5861 15.8399C20.4581 15.8399 20.3301 15.7909 20.2321 15.6939L16.6961 12.1579C16.5011 11.9629 16.5011 11.6459 16.6961 11.4509C16.8911 11.2559 17.2081 11.2559 17.4031 11.4509L20.9391 14.9869C21.1341 15.1819 21.1341 15.4989 20.9391 15.6939C20.8421 15.7909 20.7141 15.8399 20.5861 15.8399Z"
        fill={getColor(active)}
      />
      <path
        d="M6.84 21H2C0.897 21 0 20.103 0 19V2C0 0.897 0.897 0 2 0H17C18.103 0 19 0.897 19 2V6.88C19 7.156 18.776 7.38 18.5 7.38C18.224 7.38 18 7.156 18 6.88V2C18 1.449 17.551 1 17 1H2C1.449 1 1 1.449 1 2V19C1 19.551 1.449 20 2 20H6.84C7.116 20 7.34 20.224 7.34 20.5C7.34 20.776 7.116 21 6.84 21Z"
        fill={getColor(active)}
      />
      <path
        d="M18.5 6H0.5C0.224 6 0 5.776 0 5.5C0 5.224 0.224 5 0.5 5H18.5C18.776 5 19 5.224 19 5.5C19 5.776 18.776 6 18.5 6Z"
        fill={getColor(active)}
      />
      <path
        d="M14.82 11H0.5C0.224 11 0 10.776 0 10.5C0 10.224 0.224 10 0.5 10H14.82C15.096 10 15.32 10.224 15.32 10.5C15.32 10.776 15.096 11 14.82 11Z"
        fill={getColor(active)}
      />
      <path
        d="M9.5 16H0.5C0.224 16 0 15.776 0 15.5C0 15.224 0.224 15 0.5 15H9.5C9.776 15 10 15.224 10 15.5C10 15.776 9.776 16 9.5 16Z"
        fill={getColor(active)}
      />
      <path
        d="M9.5 16C9.224 16 9 15.776 9 15.5V5.5C9 5.224 9.224 5 9.5 5C9.776 5 10 5.224 10 5.5V15.5C10 15.776 9.776 16 9.5 16Z"
        fill={getColor(active)}
      />
    </svg>
  );
};

export default TableStyleIcon;
